<!--
 * @Descripttion: - DisilShoes (Almadina-inspired)
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-10-28 12:05:31
-->

<template>
  <div id="details" v-if="productDetails">
    <div class="details-wrap">

      <!-- Breadcrumb -->
      <div class="am-breadcrumb">
        <router-link to="/">Home</router-link>
        <span class="sep">&gt;</span>
        <span>{{ productDetails.name }}</span>
      </div>

      <!-- Product section -->
      <div class="am-product-row">
        <!-- Left: Image carousel -->
        <div class="am-product-images">
          <el-carousel height="600px" v-if="productPictures.length > 1">
            <el-carousel-item v-for="item in productPictures" :key="item.id">
              <img :src="item.img_path" />
            </el-carousel-item>
          </el-carousel>
          <div v-else-if="productPictures.length === 1" class="single-img">
            <img :src="productPictures[0].img_path" />
          </div>
        </div>

        <!-- Right: Product info -->
        <div class="am-product-info">
          <h1 class="am-pname">{{ productDetails.name }}</h1>

          <div class="am-price-row">
            <span class="am-discount-price">{{ formatPrice(unitPrice) }}</span>
            <span
              v-if="productDetails.price != productDetails.discount_price"
              class="am-original-price"
            >{{ formatPrice(productDetails.price) }}</span>
          </div>

          <p class="am-tax-info">Tax included. Free shipping</p>

          <!-- Buy More Save More -->
          <div class="am-bmsm">
            <div class="am-bmsm-title">Buy More Save More</div>
            <div class="am-bmsm-line"></div>
            <div class="am-tiers">
              <div
                v-for="(tier, idx) in buyTiers"
                :key="idx"
                class="am-tier"
                :class="{ active: selectedTier === idx }"
                @click="selectTier(idx)"
              >
                <span class="am-tier-radio">
                  <span v-if="selectedTier === idx" class="radio-dot"></span>
                </span>
                <div class="am-tier-info">
                  <strong>Buy {{ tier.qty }}</strong>
                  <em class="am-tier-label">{{ tier.label }}</em>
                </div>
                <div class="am-tier-price">
                  <span class="am-tier-now">{{ formatPrice(tier.total) }}</span>
                  <span v-if="tier.orig > tier.total" class="am-tier-was">{{ formatPrice(tier.orig) }}</span>
                </div>
              </div>
            </div>

            <!-- Quantity -->
            <div class="am-qty-row">
              <label>Quantity</label>
              <div class="am-qty-ctrl">
                <button @click="changeQty(-1)" :disabled="quantity <= 1">−</button>
                <span>{{ quantity }}</span>
                <button @click="changeQty(1)">+</button>
              </div>
            </div>

            <!-- Size Selector -->
            <div class="am-size-row">
              <label>Size <span class="am-size-optional">(Optional)</span></label>
              <div class="am-size-options">
                <button
                  v-for="s in ['37', '38', '39', '40', '41', '42', '43', '44']"
                  :key="s"
                  class="am-size-btn"
                  :class="{ active: selectedSize === s }"
                  @click="selectedSize = selectedSize === s ? '' : s"
                >{{ s }}</button>
              </div>
            </div>
          </div>

          <!-- Action buttons -->
          <button class="am-add-cart" :disabled="dis" @click="addToCart">Add To Cart</button>
          <button class="am-cod" @click="buyNow">Buy with Cash on Delivery</button>
        </div>
      </div>

      <!-- Policy badges -->
      <div class="am-policies">
        <div class="am-pol-item">
          <i class="el-icon-circle-check"></i>
          <span>Self-operated Mall</span>
        </div>
        <div class="am-pol-item">
          <i class="el-icon-circle-check"></i>
          <span>Fast delivery</span>
        </div>
        <div class="am-pol-item">
          <i class="el-icon-circle-check"></i>
          <span>7-day no reason return</span>
        </div>
        <div class="am-pol-item">
          <i class="el-icon-circle-check"></i>
          <span>7-day price protection</span>
        </div>
      </div>

      <!-- Customer Reviews -->
      <div class="am-reviews">
        <h2 class="am-review-heading">Customer Reviews</h2>
        <div class="am-stars">
          <i class="el-icon-star-off" v-for="i in 5" :key="i"></i>
        </div>
        <p class="am-no-reviews">There are no reviews yet.</p>
        <button class="am-write-review">Write a review</button>
      </div>

      <!-- People Also Bought -->
      <div class="am-related" v-if="relatedProducts.length">
        <h2 class="am-related-heading">People Also Bought</h2>
        <p class="am-related-sub">Here's some of our most similar products people are buying. Click to discover trending style.</p>
        <div class="am-related-grid">
          <div
            v-for="item in relatedProducts"
            :key="item.id"
            class="am-related-card"
            @click="$router.push('/goods/details?productID=' + item.id)"
          >
            <div class="am-related-img-wrap">
              <img :src="item.img_path" />
              <i class="el-icon-star-off am-heart-btn" @click.stop="addFavProduct(item.id)"></i>
            </div>
            <h4>{{ item.name }}</h4>
            <p class="am-related-price">{{ formatPrice(item.discount_price || item.price) }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="not-found" v-else>Unable to find the product</div>
</template>

<script>
import { mapActions } from 'vuex'
import * as productsAPI from '@/api/products/'
import * as favoritesAPI from '@/api/favorites/'
import * as cartsAPI from '@/api/carts/'

export default {
  data() {
    return {
      dis: false,
      productID: 0,
      productDetails: '',
      productPictures: [],
      selectedTier: 0,
      quantity: 1,
      selectedSize: '',
      relatedProducts: []
    }
  },
  computed: {
    unitPrice() {
      return this.productDetails.discount_price || this.productDetails.price
    },
    buyTiers() {
      const price = this.unitPrice
      const origPrice = this.productDetails.price || price
      return [
        {
          qty: 1,
          label: 'Standard Price',
          total: price,
          orig: origPrice
        },
        {
          qty: 2,
          label: '10% OFF',
          total: +(price * 2 * 0.9).toFixed(2),
          orig: +(origPrice * 2).toFixed(2)
        },
        {
          qty: 3,
          label: '15% OFF',
          total: +(price * 3 * 0.85).toFixed(2),
          orig: +(origPrice * 3).toFixed(2)
        }
      ]
    }
  },
  activated() {
    if (this.$route.query.productID != undefined) {
      this.productID = Number(this.$route.query.productID)
    }
  },
  watch: {
    productID() {
      this.load()
    }
  },
  methods: {
    ...mapActions(['unshiftShoppingCart', 'addShoppingCartNum']),

    formatPrice(val) {
      if (val === undefined || val === null) return '₹0'
      return '₹' + Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    selectTier(idx) {
      this.selectedTier = idx
      this.quantity = this.buyTiers[idx].qty
    },

    changeQty(delta) {
      const newQty = this.quantity + delta
      if (newQty < 1) return
      this.quantity = newQty
      // Auto-select matching tier
      if (newQty >= 3) this.selectedTier = 2
      else if (newQty >= 2) this.selectedTier = 1
      else this.selectedTier = 0
    },

    load() {
      productsAPI.showProduct(this.productID).then(res => {
        this.productDetails = res.data
        // Load related products from same category
        if (res.data && res.data.category_id) {
          this.loadRelated(res.data.category_id)
        }
      })
      productsAPI.showPictures(this.productID).then(res => {
        this.productPictures = Array.isArray(res.data) ? res.data : []
      })
    },

    loadRelated(categoryId) {
      productsAPI
        .listProducts(categoryId, 0, 4)
        .then(res => {
          if (res.status === 200) {
            const items = Array.isArray(res.data.items) ? res.data.items : []
            this.relatedProducts = items.filter(p => p.id !== this.productID).slice(0, 4)
          }
        })
        .catch(() => {})
    },

    addToCart() {
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      const qty = this.buyTiers[this.selectedTier].qty
      const form = {
        user_id: this.$store.getters.getUser.id,
        product_id: Number(this.productID),
        num: qty,
        size: this.selectedSize || ''
      }
      cartsAPI
        .postCart(form)
        .then(res => {
          switch (res.status) {
            case 200:
              this.unshiftShoppingCart(res.data)
              this.notifySucceed('Added to cart successfully')
              break
            case 201:
              this.addShoppingCartNum(this.productID)
              this.notifySucceed('Product already in cart, quantity +1')
              break
            case 202:
              this.dis = true
              this.notifyError('Product reached purchase limit', res.msg)
              break
            case 20001:
              this.loginExpired(res.msg)
              break
            default:
              this.notifyError('Add to cart failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Add to cart failed', err)
        })
    },

    buyNow() {
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      this.addToCart()
    },

    addFavProduct(productId) {
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      const form = {
        user_id: this.$store.getters.getUser.id,
        product_id: productId
      }
      favoritesAPI
        .postFavorite(form)
        .then(res => {
          if (res.status === 200) {
            this.notifySucceed('Favorite added successfully')
          } else if (res.status === 20001) {
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Add Favorite Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Add Favorite Failed', err)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    document.querySelector('body').setAttribute('style', 'background-color:#ffffff')
    next()
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector('body').setAttribute('style', 'background-color:#FAF5EF')
    next()
  }
}
</script>

<style scoped>
.details-wrap {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px 60px;
}

/* Breadcrumb */
.am-breadcrumb {
  padding: 20px 0;
  font-size: 13px;
}

.am-breadcrumb a {
  color: #8B5A3C;
  text-decoration: none;
}

.am-breadcrumb a:hover {
  text-decoration: underline;
}

.am-breadcrumb .sep {
  margin: 0 8px;
  color: #999;
}

.am-breadcrumb span:last-child {
  color: #8B5A3C;
  font-weight: 600;
}

/* Product row - image left, info right */
.am-product-row {
  display: flex;
  gap: 48px;
  align-items: flex-start;
}

/* Image carousel */
.am-product-images {
  flex: 0 0 560px;
  width: 560px;
}

.am-product-images img {
  width: 100%;
  height: 600px;
  object-fit: cover;
  border-radius: 8px;
}

.am-product-images .single-img img {
  width: 100%;
  height: 600px;
  object-fit: cover;
  border-radius: 8px;
}

/* Product info */
.am-product-info {
  flex: 1;
  min-width: 0;
}

.am-pname {
  font-size: 28px;
  font-weight: 700;
  color: #2A1F1A;
  margin: 0 0 16px;
  line-height: 1.3;
}

/* Price row */
.am-price-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 6px;
}

.am-discount-price {
  font-size: 24px;
  font-weight: 700;
  color: #2A1F1A;
}

.am-original-price {
  font-size: 16px;
  color: #999;
  text-decoration: line-through;
}

.am-tax-info {
  font-size: 13px;
  color: #888;
  margin: 0 0 28px;
}

/* Buy More Save More */
.am-bmsm {
  margin-bottom: 28px;
}

.am-bmsm-title {
  font-size: 18px;
  font-weight: 700;
  color: #2A1F1A;
  text-decoration: underline;
  text-underline-offset: 6px;
  margin-bottom: 8px;
}

.am-bmsm-line {
  height: 1px;
  background: #E2E8F0;
  margin-bottom: 16px;
}

/* Tier options */
.am-tiers {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.am-tier {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border: 1.5px solid #E2E8F0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.am-tier:hover {
  border-color: #C4B5FD;
}

.am-tier.active {
  border-color: #8B5A3C;
  background: #F5F3FF;
}

/* Radio indicator */
.am-tier-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #C4B5FD;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.am-tier.active .am-tier-radio {
  border-color: #8B5A3C;
}

.radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #8B5A3C;
}

/* Tier text */
.am-tier-info {
  flex: 1;
  min-width: 0;
}

.am-tier-info strong {
  font-size: 15px;
  color: #2A1F1A;
}

.am-tier-label {
  display: block;
  font-size: 12px;
  color: #888;
  font-style: normal;
  margin-top: 2px;
}

.am-tier-price {
  text-align: right;
  flex-shrink: 0;
}

.am-tier-now {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #2A1F1A;
}

.am-tier-was {
  display: block;
  font-size: 13px;
  color: #999;
  text-decoration: line-through;
  margin-top: 2px;
}

/* Quantity selector */
.am-qty-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.am-qty-row label {
  font-size: 14px;
  font-weight: 600;
  color: #2A1F1A;
}

.am-qty-ctrl {
  display: flex;
  align-items: center;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  overflow: hidden;
}

.am-qty-ctrl button {
  width: 36px;
  height: 36px;
  background: #FAF5EF;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #2A1F1A;
  transition: background 0.2s;
}

.am-qty-ctrl button:hover:not(:disabled) {
  background: #E2E8F0;
}

.am-qty-ctrl button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.am-qty-ctrl span {
  width: 48px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #2A1F1A;
  background: #fff;
}

/* Size Selector */
.am-size-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}

.am-size-row label {
  font-size: 14px;
  font-weight: 600;
  color: #2A1F1A;
}

.am-size-optional {
  font-weight: 400;
  font-size: 12px;
  color: #999;
  margin-left: 4px;
}

.am-size-options {
  display: flex;
  gap: 10px;
}

.am-size-btn {
  width: 48px;
  height: 40px;
  border: 1.5px solid #E2E8F0;
  border-radius: 6px;
  background: #fff;
  font-size: 15px;
  font-weight: 600;
  color: #2A1F1A;
  cursor: pointer;
  transition: all 0.2s;
}

.am-size-btn:hover {
  border-color: #C4B5FD;
  background: #F5F3FF;
}

.am-size-btn.active {
  border-color: #8B5A3C;
  background: #8B5A3C;
  color: #fff;
}

/* Action buttons */
.am-add-cart {
  display: block;
  width: 100%;
  padding: 16px 0;
  background: #8B5A3C;
  color: #fff;
  border: none;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background 0.3s;
  border-radius: 4px;
  margin-bottom: 12px;
}

.am-add-cart:hover:not(:disabled) {
  background: #6B4226;
}

.am-add-cart:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.am-cod {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 0;
  background: #2A1F1A;
  color: #fff;
  border: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
  border-radius: 4px;
}

.am-cod:hover {
  background: #4A352A;
}

/* Policies */
.am-policies {
  display: flex;
  gap: 32px;
  padding: 28px 0;
  border-top: 1px solid #E2E8F0;
  border-bottom: 1px solid #E2E8F0;
  margin-top: 48px;
}

.am-pol-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
}

.am-pol-item i {
  font-size: 16px;
  color: #8B5A3C;
}

/* Customer Reviews */
.am-reviews {
  padding: 48px 0;
  text-align: center;
  border-bottom: 1px solid #E2E8F0;
}

.am-review-heading {
  font-size: 24px;
  font-weight: 700;
  color: #2A1F1A;
  margin: 0 0 20px;
}

.am-stars {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 12px;
}

.am-stars i {
  font-size: 22px;
  color: #C4B5FD;
}

.am-no-reviews {
  font-size: 14px;
  color: #888;
  margin: 0 0 20px;
}

.am-write-review {
  padding: 10px 28px;
  background: #fff;
  color: #8B5A3C;
  border: 1.5px solid #8B5A3C;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.am-write-review:hover {
  background: #8B5A3C;
  color: #fff;
}

/* People Also Bought */
.am-related {
  padding: 56px 0 0;
}

.am-related-heading {
  font-size: 28px;
  font-weight: 700;
  color: #4E2A0E;
  text-align: center;
  margin: 0 0 8px;
}

.am-related-sub {
  font-size: 13px;
  color: #4E2A0E;
  text-align: center;
  margin: 0 0 32px;
}

.am-related-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
}

.am-related-card {
  flex: 1;
  cursor: pointer;
  transition: transform 0.3s;
}

.am-related-card:hover {
  transform: translateY(-4px);
}

.am-related-img-wrap {
  position: relative;
  margin-bottom: 12px;
}

.am-related-img-wrap img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
}

.am-heart-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #888;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: color 0.2s;
}

.am-heart-btn:hover {
  color: #4E2A0E;
}

.am-related-card h4 {
  font-size: 14px;
  font-weight: 600;
  color: #2A1F1A;
  margin: 0 0 6px;
  line-height: 1.4;
  min-height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.am-related-price {
  font-size: 15px;
  font-weight: 700;
  color: #2A1F1A;
  margin: 0;
}

/* Not found */
.not-found {
  height: 500px;
  text-align: center;
  line-height: 500px;
  font-size: 18px;
  color: #888;
}

/* ===== Responsive ===== */
@media (max-width: 900px) {
  .details-wrap {
    padding: 0 16px 40px;
  }

  .am-product-row {
    flex-direction: column;
    gap: 24px;
  }

  .am-product-images {
    flex: none;
    width: 100%;
  }

  .am-product-images img,
  .am-product-images .single-img img {
    height: 400px;
  }

  .am-pname {
    font-size: 22px;
  }

  .am-policies {
    flex-wrap: wrap;
    gap: 16px;
  }

  .am-related-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 14px;
  }

  .am-add-cart,
  .am-cod {
    font-size: 15px;
  }
}
</style>
